import React from 'react';
import { Typography } from '../../../../wag-react/components/Typography';
import { Box } from '../../../../wag-react/next-components/box';
import { Flex } from '../../../../wag-react/next-components/Flex';
import { theme } from '../../../../wag-react/themes/base-theme';
export type CommentProps = {
  datePosted: string;
  text: string;
  userLabel?: string;
};
export const Comment = ({
  datePosted,
  text,
  userLabel
}: CommentProps) => <Box px={['16px', '24px']} py="16px" data-sentry-element="Box" data-sentry-component="Comment" data-sentry-source-file="index.tsx">
    <Typography m={0} data-sentry-element="Typography" data-sentry-source-file="index.tsx">
      {text}
    </Typography>
    <Flex justifyContent="space-between" mt="16px" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
      <Typography color={theme.colors.darkGray} fontSize="14px" m={0} data-sentry-element="Typography" data-sentry-source-file="index.tsx">
        {datePosted}
      </Typography>

      {userLabel && <Typography color={theme.colors.darkGray} fontSize="14px" m={0}>
          {userLabel}
        </Typography>}
    </Flex>
  </Box>;